import { clientPortalApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { UserPermissionResponse } from 'src/types';

export const getUserPermissionsByCompany = (userId: string, companyId: string, config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<UserPermissionResponse[]>(`/api/v1/permissions/users/${userId}/companies/${companyId}`, config);
